import styled from "styled-components";

export const ButtonStyled = styled.button`
  border: 2px solid #6bbb99;
  display: flex;
  transition: all 0.3s ease;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  font-size: ${({ largeFont }) => (largeFont ? "18px" : "14px")};
  font-weight: ${({ largeFont }) => (largeFont ? "bold" : "500")};
  letter-spacing: 0.02857em;
  width: ${({ width }) => width || "120px"};
  padding: ${({ padding }) => padding};
  height: ${({ height }) => height || "64px"};
  background-color: ${({ outlined }) => (outlined ? "transparent" : "#6bbb99")};
  text-transform: capitalize;
  cursor: pointer;
  outline: 0;
  margin: ${({ margin }) => margin || "0"};
  box-shadow: ${({ outlined }) =>
    outlined ? "none" : "0px 10px 24px #E0FBF1"};

  &:active,
  &:focus {
    outline: 0;
    border: none;
  }

  &:hover {
    box-shadow: none;
    background-color: #4c846c;
    border: none;
    color: white;
  }

  &:disabled {
    background: gray;
    border: none;
    color: #fff;
    cursor: not-allowed;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  color: ${({ outlined }) => (outlined ? "#6bbb99" : "#fff")};

  @media (max-width: 600px) {
    height: 45px;
    font-weight: 500;
  }
`;
